import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import SelectField from '../../../../FormControl/input/SelectField';
import { useSelector } from 'react-redux';
import SelectCurriculumElements from './SelectCurriculumElements';

const FormCurriculumElements = ({ onChange, form = {}, errors = {}, showTitle, curriculumId }) => {
  const curriculumList = useSelector((state) => state?.assessment?.curriculum);

  return (
    <>
      {showTitle && (
        <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center'>
          <Typography variant='inherit' className='font-bold capitalize' component='p'>
            Curriculum Elements
          </Typography>
        </Box>
      )}
      <Box className={showTitle ? 'px-4 py-4' : 'py-4'}>
        <Grid container spacing={2} alignItems='center'>
          <Grid item  sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              Curriculum
            </Typography>
          </Grid>
          <Grid item sm={9}>
            {form?.unitOfLearnings?.length > 0 ? (
              <Typography variant='inherit' component='p'>
                {curriculumList?.find((item) => form.curriculumId === item._id)?.name}
              </Typography>
            ) : (
              <SelectField
                id='curriculumId'
                name='curriculumId'
                error={errors.curriculumId}
                helperText={errors.curriculumId}
                value={form.curriculumId}
                onChange={(e) => onChange('curriculumId', e.target.value)}
                placeholder={'Choose a curriculum'}
                options={
                  curriculumList.map((item) => ({
                    value: item._id,
                    label: `${item.shortName} - ${item.name}`
                  })) || []
                }
              />
            )}
          </Grid>
          <SelectCurriculumElements
            onChangeAlert={onChange}
            currentCurriculum={curriculumList.find((item) => String(item._id) === String(form.curriculumId))}
            formData={form?.curriculumElements || {}}
            errors={errors}
            curriculumId={curriculumId}
            isPreview={form?.unitOfLearnings?.length > 0}
          />
        </Grid>
      </Box>
    </>
  );
};

export default FormCurriculumElements;
